import { isEuropeanWorld,europeanCities,europeanLandmarks } from './europeanWorlds.ts'
import { isAsianWorld,asianCities,asianLandmarks } from './asianWorlds.ts'
export const regionalCities={...europeanCities,...asianCities}
export const isRegionalWorld=(id:string|undefined):id is keyof typeof regionalCities=>isEuropeanWorld(id)||isAsianWorld(id)
export const regionalLandmarks=(id:keyof typeof regionalCities)=>isAsianWorld(id)?asianLandmarks(id):europeanLandmarks(id)
